const CHUNK_ERROR_RELOAD_COOLDOWN_MS = 10_000;

export function safeImport<T>(importer: () => Promise<T>) {
  return () =>
    importer().catch((err) => {
      console.error("Chunk load error", err);
      throw err;
    });
}

export function isChunkLoadError(error: unknown): boolean {
  if (!(error instanceof Error)) {
    return false;
  }

  return (
    error.name === "ChunkLoadError" ||
    /Loading (CSS )?chunk .+ failed/.test(error.message) ||
    error.message.includes("Unexpected token '<'")
  );
}

// Guards against a reload loop when the chunk is really missing, not just stale.
export function shouldReloadForChunkError(
  now: number,
  lastReloadAt: string | null
): boolean {
  return (
    lastReloadAt === null ||
    now - Number(lastReloadAt) > CHUNK_ERROR_RELOAD_COOLDOWN_MS
  );
}
